type UserIconProps = {
  size?: number
}

export function UserIcon({ size = 24 }: UserIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="-2 -2 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M9.99899 11.9893C12.0487 11.9893 14.0452 12.6407 15.7011 13.8486C16.8031 14.6525 17.7166 15.6751 18.3886 16.8447C18.7739 17.5153 18.6926 18.2538 18.3213 18.8027C17.9584 19.3389 17.3272 19.6895 16.6133 19.6895H3.38474C2.67074 19.6894 2.03957 19.3389 1.67673 18.8027C1.30541 18.2538 1.22408 17.5153 1.60934 16.8447C2.28142 15.6752 3.19492 14.6525 4.29684 13.8486C5.95281 12.6407 7.94926 11.9893 9.99899 11.9893ZM9.99899 13.4893C8.26713 13.4893 6.57984 14.039 5.18063 15.0596C4.24963 15.7387 3.47802 16.6036 2.91013 17.5918C2.83115 17.7293 2.84567 17.8522 2.91989 17.9619C3.00273 18.0841 3.16689 18.1894 3.38474 18.1895H16.6133C16.8311 18.1895 16.9952 18.0841 17.0781 17.9619C17.1523 17.8522 17.1669 17.7294 17.0879 17.5918C16.52 16.6036 15.7484 15.7387 14.8174 15.0596C13.4181 14.039 11.7309 13.4893 9.99899 13.4893Z" fillRule="evenodd" clipRule="evenodd" fill="currentColor" />
      <path d="M9.99899 0.30957C12.8817 0.309739 15.2195 2.64659 15.2197 5.5293C15.2196 8.41207 12.8817 10.7498 9.99899 10.75C7.11625 10.7498 4.77937 8.41206 4.77927 5.5293C4.77945 2.6466 7.1163 0.309753 9.99899 0.30957ZM9.99899 1.80957C7.94473 1.80975 6.27945 3.47503 6.27927 5.5293C6.27937 7.58364 7.94467 9.24982 9.99899 9.25C12.0533 9.24983 13.7196 7.58364 13.7197 5.5293C13.7195 3.47502 12.0533 1.80974 9.99899 1.80957Z" fillRule="evenodd" clipRule="evenodd" fill="currentColor" />
    </svg>
  )
}
